<template>
  <b-badge
    class="network-status-badge"
    pill
    :variant="variant"
    v-text="label"
  />
</template>

<script>
import { networkStatusTypes } from '@/domain/enums/networkStatus';

export default {
  props: {
    value: String,
  },
  computed: {
    variant() {
      switch (this.value) {
        case networkStatusTypes.ACTIVE:
          return 'active';
        case networkStatusTypes.INACTIVE:
          return 'inactive';
        default:
          return 'indeterminate';
      }
    },
    label() {
      return this.$t(`network-status.status.${this.value}`);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
@import "src/styles/vendor/customizations/custom-bootstrap-vars.sass"
@import ~bootstrap/scss/mixins/_badge
@import ~bootstrap/scss/mixins/_hover
@import "src/styles/components/badge-default-colors.sass"

.network-status-badge
  padding: 5px
  &.badge-active
    @include badge-variant($status-active)
    color: #fff
  &.badge-inactive
    @include badge-variant($status-inactive)
    color: #fff
  &.badge-indeterminate
    @include badge-variant($color-extend-pink)
    color: #fff
</style>
